/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://bipocdoceditors.com/api/v1";
        // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:3000/api/v1";
    }

    /**
     * Create a new user
     * @param body User to create
     * @return User created successfully
     */
    user(body: Body): Observable<Response> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processUser(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Search users as admin
     * @param keyword (optional)
     * @return All went good.
     */
    user2(keyword: string | undefined): Observable<Anonymous> {
        let url_ = this.baseUrl + "/user?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "appication/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser2(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous>><any>_observableThrow(response_);
        }));
    }

    protected processUser2(response: HttpResponseBase): Observable<Anonymous> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Anonymous2>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Users were not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous3>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous>(<any>null);
    }

    /**
     * resets password
     * @param body User to Autenticate
     * @return password changed succesfully
     */
    reset(body: Body2): Observable<Anonymous4> {
        let url_ = this.baseUrl + "/user/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReset(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous4>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous4>><any>_observableThrow(response_);
        }));
    }

    protected processReset(response: HttpResponseBase): Observable<Anonymous4> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous4>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous5>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous4>(<any>null);
    }

    /**
     * sets the token so that password can be reseted
     * @param email Email of the user to reset password.
     * @return password reset token was setted correctly
     */
    recover(email: string): Observable<Anonymous6> {
        let url_ = this.baseUrl + "/user/recover/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecover(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous6>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous6>><any>_observableThrow(response_);
        }));
    }

    protected processRecover(response: HttpResponseBase): Observable<Anonymous6> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous6>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous7>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error setting the token", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous6>(<any>null);
    }

    /**
     * Deletes users as admin
     * @param _ids id of the highlight
     * @return signin success
     */
    user3(_ids: string): Observable<Anonymous8> {
        let url_ = this.baseUrl + "/user/{_ids}";
        if (_ids === undefined || _ids === null)
            throw new Error("The parameter '_ids' must be defined.");
        url_ = url_.replace("{_ids}", encodeURIComponent("" + _ids));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser3(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous8>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous8>><any>_observableThrow(response_);
        }));
    }

    protected processUser3(response: HttpResponseBase): Observable<Anonymous8> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous8>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous9>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Athentication error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous8>(<any>null);
    }

    /**
     * Changes the role of the given user.
     * @param _id id of the highlight
     * @param role Role to change
     * @return signin success
     */
    changerole(_id: string, role: Role): Observable<Anonymous10> {
        let url_ = this.baseUrl + "/user/changerole/{_id}?";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined and cannot be null.");
        else
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangerole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangerole(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous10>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous10>><any>_observableThrow(response_);
        }));
    }

    protected processChangerole(response: HttpResponseBase): Observable<Anonymous10> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous10>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous11>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous12>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous10>(<any>null);
    }

    /**
     * Search users by a given role.
     * @param role Role to change
     * @return Results of search
     */
    role(role: Role2): Observable<Anonymous13> {
        let url_ = this.baseUrl + "/user/role?";
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined and cannot be null.");
        else
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRole(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous13>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous13>><any>_observableThrow(response_);
        }));
    }

    protected processRole(response: HttpResponseBase): Observable<Anonymous13> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous13>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Anonymous14>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("No users were found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous15>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous13>(<any>null);
    }

    /**
     * Autenticates user and returns jwt
     * @param body User to Autenticate
     * @return signin success
     */
    signin(body: Body3): Observable<Response> {
        let url_ = this.baseUrl + "/user/signin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignin(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processSignin(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Athentication error", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Creates a new profile with a given token.
     * @param body (optional)
     * @return Profile created successfully.
     */
    profile(body: Body4 | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processProfile(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Get users with a given status
     * @return All went good
     */
    profile2(status: string): Observable<Anonymous16> {
        let url_ = this.baseUrl + "/profile?";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfile2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile2(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous16>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous16>><any>_observableThrow(response_);
        }));
    }

    protected processProfile2(response: HttpResponseBase): Observable<Anonymous16> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous16>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous16>(<any>null);
    }

    /**
     * Get profile by either user or profile id.
     * @return User found
     */
    profile3(id: string): Observable<Anonymous17> {
        let url_ = this.baseUrl + "/profile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfile3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile3(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous17>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous17>><any>_observableThrow(response_);
        }));
    }

    protected processProfile3(response: HttpResponseBase): Observable<Anonymous17> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous17>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous17>(<any>null);
    }

    /**
     * Updates a profile with the new Interface
     * @param body (optional)
     * @return User updated successfully.
     */
    profile4(id: string, body: Body5 | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/profile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfile4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile4(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processProfile4(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected error.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Deletes profile by id, you can use either the user id or the profile id.
     * @return User successfully deleted.
     * @deprecated
     */
    profile5(id: string): Observable<Response> {
        let url_ = this.baseUrl + "/profile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfile5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile5(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processProfile5(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected error.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Sets the verified flag
     * @param verified (optional)
     * @return The profile was successfully updated
     */
    status(id: string, verified: boolean | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/profile/status/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (verified === null)
            throw new Error("The parameter 'verified' cannot be null.");
        else if (verified !== undefined)
            url_ += "verified=" + encodeURIComponent("" + verified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Sets resume file.
     * @param file (optional)
     * @return The resume was uploaded successfully!.
     */
    resume(id: string, file: FileParameter | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/profile/resume/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResume(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processResume(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Sets or updates profile image.
     * @param file (optional)
     * @return The image was changed successfully!.
     */
    photo(id: string, imageType: ImageType, file: FileParameter | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/profile/photo/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (imageType === undefined || imageType === null)
            throw new Error("The parameter 'imageType' must be defined and cannot be null.");
        else
            url_ += "imageType=" + encodeURIComponent("" + imageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoto(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processPhoto(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Deletes given picture
     * @return Image successfully deleted
     */
    photo2(id: string, imageType: ImageType2): Observable<Anonymous18> {
        let url_ = this.baseUrl + "/profile/photo/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (imageType === undefined || imageType === null)
            throw new Error("The parameter 'imageType' must be defined and cannot be null.");
        else
            url_ += "imageType=" + encodeURIComponent("" + imageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoto2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoto2(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous18>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous18>><any>_observableThrow(response_);
        }));
    }

    protected processPhoto2(response: HttpResponseBase): Observable<Anonymous18> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous18>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Anonymous19>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("User does not have an image", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous20>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous18>(<any>null);
    }

    /**
     * Searches profile acording to query.
     * @param body (optional)
     * @return Profiles found successfully.
     */
    search(body: SearchQuery | undefined): Observable<Anonymous21> {
        let url_ = this.baseUrl + "/profile/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous21>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous21>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<Anonymous21> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous21>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("No profiles found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous21>(<any>null);
    }

    /**
     * Returns 11 random images from registered verified profiles.
     * @return All went good.
     */
    images(): Observable<Anonymous22> {
        let url_ = this.baseUrl + "/profile/random/images";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImages(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous22>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous22>><any>_observableThrow(response_);
        }));
    }

    protected processImages(response: HttpResponseBase): Observable<Anonymous22> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous22>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Anonymous23>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Any users were found.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous24>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous22>(<any>null);
    }

    /**
     * Sends contact message to admins.
     * @param body (optional)
     * @return Contact message successfully registered
     */
    contact(body: Body6 | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContact(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processContact(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client error", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Searches contact messages
     * @param keyword (optional)
     * @return Search performed successfully
     */
    contact2(keyword: string | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/contact?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContact2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContact2(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processContact2(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("We couldnt find any messages", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * deletes contact messages as admin
     * @return Contact messages were successfully deleted.
     */
    contact3(id: string): Observable<Response> {
        let url_ = this.baseUrl + "/contact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContact3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContact3(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processContact3(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Send emails as admin
     * @param body (optional) Email information
     * @return Emails sent
     */
    emails(emails: string, body: Body7 | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/emails/{emails}";
        if (emails === undefined || emails === null)
            throw new Error("The parameter 'emails' must be defined.");
        url_ = url_.replace("{emails}", encodeURIComponent("" + emails));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmails(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processEmails(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Creates a new resource
     * @param title (optional)
     * @param subtitle (optional)
     * @param description (optional)
     * @param image (optional)
     * @param link (optional)
     * @return The resource was created successfully
     */
    resources(title: string | undefined, subtitle: string | undefined, description: string | undefined, image: FileParameter | undefined, link: string | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/resources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("title", title.toString());
        if (subtitle === null || subtitle === undefined)
            throw new Error("The parameter 'subtitle' cannot be null.");
        else
            content_.append("subtitle", subtitle.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("description", description.toString());
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");
        if (link === null || link === undefined)
            throw new Error("The parameter 'link' cannot be null.");
        else
            content_.append("link", link.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResources(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processResources(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Gets all resources.
     * @return All went good.
     */
    resources2(): Observable<Anonymous25> {
        let url_ = this.baseUrl + "/resources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResources2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResources2(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous25>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous25>><any>_observableThrow(response_);
        }));
    }

    protected processResources2(response: HttpResponseBase): Observable<Anonymous25> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous25>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous25>(<any>null);
    }

    /**
     * @param image (optional)
     * @return All went good.
     */
    photo3(_id: string, image: FileParameter | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/resources/photo/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoto3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoto3(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processPhoto3(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * Deletes resource.
     * @return All went good.
     */
    resources3(_id: string): Observable<Response> {
        let url_ = this.baseUrl + "/resources/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResources3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResources3(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processResources3(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * updates given resource
     * @param body (optional)
     * @return All went good.
     */
    resources4(_id: string, body: Body8 | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/resources/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResources4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResources4(<any>response_);
                } catch (e) {
                    return <Observable<Response>><any>_observableThrow(e);
                }
            } else
                return <Observable<Response>><any>_observableThrow(response_);
        }));
    }

    protected processResources4(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Response>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Response>(<any>null);
    }

    /**
     * @return Endorsers
     */
    endorser(): Observable<Anonymous26> {
        let url_ = this.baseUrl + "/endorser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndorser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndorser(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous26>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous26>><any>_observableThrow(response_);
        }));
    }

    protected processEndorser(response: HttpResponseBase): Observable<Anonymous26> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous26>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous26>(<any>null);
    }

    /**
     * @param image (optional)
     * @param title (optional)
     * @param subtitle (optional)
     * @return The endorser was successfully created.
     */
    endorser2(image: FileParameter | undefined, title: string | undefined, subtitle: string | undefined): Observable<Anonymous27> {
        let url_ = this.baseUrl + "/endorser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("title", title.toString());
        if (subtitle === null || subtitle === undefined)
            throw new Error("The parameter 'subtitle' cannot be null.");
        else
            content_.append("subtitle", subtitle.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndorser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndorser2(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous27>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous27>><any>_observableThrow(response_);
        }));
    }

    protected processEndorser2(response: HttpResponseBase): Observable<Anonymous27> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Anonymous27>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous28>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous29>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous27>(<any>null);
    }

    /**
     * Update an endorser
     * @param _id Endorser ID.
     * @param body (optional)
     * @return The given endorser was succcessfully updated.
     */
    endorser3(_id: string, body: Body9 | undefined): Observable<Anonymous30> {
        let url_ = this.baseUrl + "/endorser/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndorser3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndorser3(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous30>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous30>><any>_observableThrow(response_);
        }));
    }

    protected processEndorser3(response: HttpResponseBase): Observable<Anonymous30> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous30>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous31>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous32>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous30>(<any>null);
    }

    /**
     * Deletes an endorser with a given id.
     * @param _id id of the partner to erase
     * @return The given endorser was successfully deleted.
     */
    endorser4(_id: string): Observable<Anonymous33> {
        let url_ = this.baseUrl + "/endorser/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndorser4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndorser4(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous33>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous33>><any>_observableThrow(response_);
        }));
    }

    protected processEndorser4(response: HttpResponseBase): Observable<Anonymous33> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous33>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous34>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous35>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous33>(<any>null);
    }

    /**
     * Updates endorser photo.
     * @param _id id of the partner to erase
     * @param image (optional)
     * @return The endorser photo was succesfully updated.
     */
    photo4(_id: string, image: FileParameter | undefined): Observable<Anonymous36> {
        let url_ = this.baseUrl + "/endorser/photo/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPhoto4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPhoto4(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous36>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous36>><any>_observableThrow(response_);
        }));
    }

    protected processPhoto4(response: HttpResponseBase): Observable<Anonymous36> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous36>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous37>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous38>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Unexpected server error.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous36>(<any>null);
    }

    /**
     * delete a partner
     * @param _id id of the partner to erase
     * @return successfuly deleted a partner
     */
    partner(_id: string): Observable<Anonymous39> {
        let url_ = this.baseUrl + "/partner/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartner(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous39>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous39>><any>_observableThrow(response_);
        }));
    }

    protected processPartner(response: HttpResponseBase): Observable<Anonymous39> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous39>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous40>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error deleting the partner", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous39>(<any>null);
    }

    /**
     * gets all partners
     * @return Partenrs fetched succcessfully.
     */
    partner2(): Observable<Anonymous41> {
        let url_ = this.baseUrl + "/partner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartner2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartner2(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous41>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous41>><any>_observableThrow(response_);
        }));
    }

    protected processPartner2(response: HttpResponseBase): Observable<Anonymous41> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous41>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous42>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error creating the partner", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous41>(<any>null);
    }

    /**
     * Creates a new partner
     * @param image (optional)
     * @return Partner created succesfully
     */
    partner3(image: FileParameter | undefined): Observable<Anonymous43> {
        let url_ = this.baseUrl + "/partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartner3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartner3(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous43>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous43>><any>_observableThrow(response_);
        }));
    }

    protected processPartner3(response: HttpResponseBase): Observable<Anonymous43> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Anonymous43>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous44>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Error creating the partner", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous43>(<any>null);
    }

    /**
     * Edit a highlight
     * @param _id id of the highlight to edit
     * @param body Edit a highlight
     * @return All went good.
     */
    highlight(_id: string, body: Body10): Observable<Anonymous45> {
        let url_ = this.baseUrl + "/highlight/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHighlight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHighlight(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous45>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous45>><any>_observableThrow(response_);
        }));
    }

    protected processHighlight(response: HttpResponseBase): Observable<Anonymous45> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous45>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous46>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous45>(<any>null);
    }

    /**
     * Create a new highlight
     * @param title (optional)
     * @param info (optional)
     * @param banner (optional)
     * @param metatag (optional)
     * @param link (optional)
     * @return All went good.
     */
    highlight2(title: string | undefined, info: string | undefined, banner: FileParameter | undefined, metatag: string | undefined, link: string | undefined): Observable<Anonymous47> {
        let url_ = this.baseUrl + "/highlight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("title", title.toString());
        if (info === null || info === undefined)
            throw new Error("The parameter 'info' cannot be null.");
        else
            content_.append("info", info.toString());
        if (banner === null || banner === undefined)
            throw new Error("The parameter 'banner' cannot be null.");
        else
            content_.append("banner", banner.data, banner.fileName ? banner.fileName : "banner");
        if (metatag === null || metatag === undefined)
            throw new Error("The parameter 'metatag' cannot be null.");
        else
            content_.append("metatag", metatag.toString());
        if (link === null || link === undefined)
            throw new Error("The parameter 'link' cannot be null.");
        else
            content_.append("link", link.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHighlight2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHighlight2(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous47>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous47>><any>_observableThrow(response_);
        }));
    }

    protected processHighlight2(response: HttpResponseBase): Observable<Anonymous47> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Anonymous47>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous48>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous47>(<any>null);
    }

    /**
     * get all highlights
     * @return All went good.
     */
    highlight3(): Observable<Anonymous49> {
        let url_ = this.baseUrl + "/highlight";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHighlight3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHighlight3(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous49>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous49>><any>_observableThrow(response_);
        }));
    }

    protected processHighlight3(response: HttpResponseBase): Observable<Anonymous49> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous49>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <Anonymous50>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Athentication error", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous49>(<any>null);
    }

    /**
     * Deleta a highlight
     * @param _ids id of the highlight to erase
     * @return signin success
     */
    highlight4(_ids: string): Observable<Anonymous51> {
        let url_ = this.baseUrl + "/highlight/{_ids}";
        if (_ids === undefined || _ids === null)
            throw new Error("The parameter '_ids' must be defined.");
        url_ = url_.replace("{_ids}", encodeURIComponent("" + _ids));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHighlight4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHighlight4(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous51>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous51>><any>_observableThrow(response_);
        }));
    }

    protected processHighlight4(response: HttpResponseBase): Observable<Anonymous51> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous51>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous52>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Athentication error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous51>(<any>null);
    }

    /**
     * set the image of a highlight
     * @param _id id of the highlight
     * @param image (optional)
     * @return signin success
     */
    image(_id: string, image: FileParameter | undefined): Observable<Anonymous53> {
        let url_ = this.baseUrl + "/highlight/image/{_id}";
        if (_id === undefined || _id === null)
            throw new Error("The parameter '_id' must be defined.");
        url_ = url_.replace("{_id}", encodeURIComponent("" + _id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImage(<any>response_);
                } catch (e) {
                    return <Observable<Anonymous53>><any>_observableThrow(e);
                }
            } else
                return <Observable<Anonymous53>><any>_observableThrow(response_);
        }));
    }

    protected processImage(response: HttpResponseBase): Observable<Anonymous53> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Anonymous53>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <Anonymous54>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Athentication error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Anonymous53>(<any>null);
    }
}

export interface TokenResponse {
    token?: string;
    _id?: string;
}

export interface Response {
    error?: string;
    body?: Body11;
}

export interface User {
    name?: string;
    lastName?: string;
    email?: string;
}

export interface Poster {
    image?: string;
    referenceLink?: string;
    description?: string;
    credits?: string;
}

export interface Profile {
    user?: User;
    contactEmail: string;
    bio: string;
    receiveJobNotifs?: boolean,
    resume?: string;
    preferredPronouns?: string;
    links?: Links;
    position?: Position[];
    languages?: Languages[];
    selfIdentification?: SelfIdentification[];
    BasedIn?: BasedIn[];
    racial?: Racial[];
    documentaryExperience?: DocumentaryExperience[];
    otherExperience?: OtherExperience[];
    otherIdentities?: string;
    images?: Images;
}

export interface ProfileWithPhotos {
    user?: User;
    _id?: string;
    contactEmail?: string;
    bio?: string;
    receiveJobNotifs?: boolean,
    activelyLooking: number,
    resume?: string;
    preferredPronouns?: string;
    links?: Links2;
    position?: Position2[];
    languages?: Languages2[];
    selfIdentification?: SelfIdentification2[];
    BasedIn?: BasedIn2[];
    racial?: Racial2[];
    documentaryExperience?: DocumentaryExperience2[];
    otherExperience?: OtherExperience2[];
    otherIdentities?: string;
    images?: Images2;
}

export interface SearchQuery {
    keyword?: string;
    query?: Query;
}

export interface Body {
    name?: string;
    lastName?: string;
    email?: string;
    password?: string;
}

export interface Body2 {
    email?: string;
    bytes?: string;
    newPassword?: string;
}

export enum Role {
    Basic = "basic",
    Manager = "manager",
    Admin = "admin",
    Super = "super",
}

export enum Role2 {
    Basic = "basic",
    Manager = "manager",
    Admin = "admin",
    Super = "super",
}

export interface Body3 {
    email?: string;
    password?: string;
}

export interface Body4 {
    profile?: Profile;
}

export interface Body5 {
    profile?: Profile;
}

export enum ImageType {
    Profile = "profile",
    Poster1 = "poster1",
    Poster2 = "poster2",
    Poster3 = "poster3",
}

export enum ImageType2 {
    Profile = "profile",
    Poster1 = "poster1",
    Poster2 = "poster2",
    Poster3 = "poster3",
}

export interface Body6 {
    /** Name of the person requesting contact to the administrators */
    name?: string;
    /** Email of the person requesting contact to the administrators */
    email?: string;
    /** Motive of contact request. */
    message?: string;
}

export interface Body7 {
    email?: Email;
}

export interface Body8 {
    resource?: Resource;
}

export interface Body9 {
    endorser?: Endorser;
}

export interface Body10 {
    highlight?: Highlight;
}

export interface Anonymous {
    error?: string;
    body?: Body12[];
}

export interface Anonymous2 {
    error?: string;
    body?: string;
}

export interface Anonymous3 {
    error?: string;
    body?: string;
}

export interface Anonymous4 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous5 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous6 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous7 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous8 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous9 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous10 {
    error?: string;
    body?: string;
}

export interface Anonymous11 {
    error?: string;
    body?: string;
}

export interface Anonymous12 {
    error?: string;
    body?: string;
}

export interface Anonymous13 {
    error?: string;
    body?: Body13[];
}

export interface Anonymous14 {
    error?: string;
    body?: string;
}

export interface Anonymous15 {
    error?: string;
    body?: string;
}

export interface Anonymous16 {
    error?: string;
    body?: Body14[];
}

export interface Anonymous17 {
    body?: ProfileWithPhotos;
    error?: string;
}

export interface Anonymous18 {
    body?: string;
    error?: string;
}

export interface Anonymous19 {
    body?: string;
    error?: string;
}

export interface Anonymous20 {
    body?: string;
    error?: string;
}

export interface Anonymous21 {
    body?: ProfileWithPhotos[];
}

export interface Anonymous22 {
    error?: string;
    body?: string[];
}

export interface Anonymous23 {
    error?: string;
    body?: string;
}

export interface Anonymous24 {
    error?: string;
    body?: string;
}

export interface Anonymous25 {
    error?: string;
    body?: Body15[];
}

export interface Anonymous26 {
    body?: Body16[];
    /** Error if any */
    error?: string;
}

export interface Anonymous27 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous28 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous29 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous30 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous31 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous32 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous33 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous34 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous35 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous36 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous37 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous38 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous39 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous40 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous41 {
    body?: Body17[];
    /** Error if any */
    error?: string;
}

export interface Anonymous42 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous43 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous44 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous45 {
    body?: string;
    error?: string;
}

export interface Anonymous46 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous47 {
    body?: string;
    error?: string;
}

export interface Anonymous48 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous49 {
    body?: Body18;
    error?: string;
}

export interface Anonymous50 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous51 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous52 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous53 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Anonymous54 {
    /** Server message */
    body?: string;
    /** Error if any */
    error?: string;
}

export interface Body11 extends TokenResponse {
    user?: User;
    contactEmail: string;
    bio: string;
    resume?: string;
    preferredPronouns?: string;
    links?: Links;
    position?: Position[];
    languages?: Languages[];
    selfIdentification?: SelfIdentification[];
    BasedIn?: BasedIn[];
    racial?: Racial[];
    documentaryExperience?: DocumentaryExperience[];
    otherExperience?: OtherExperience[];
    otherIdentities?: string;
    images?: Images;
}

export interface Links {
    imdb?: string;
    linkedin?: string;
    website?: string;
    customLink?: string;
}

export enum Position {
    Editor = "Editor",
    Associate_Editor = "Associate Editor",
    Assistant_Editor = "Assistant Editor",
}

export enum Languages {
    Arabic = "Arabic",
    English = "English",
    French = "French",
    German = "German",
    Hindi = "Hindi",
    Japanese = "Japanese",
    Mandarin_Chinese = "Mandarin Chinese",
    Portuguese = "Portuguese",
    Russian = "Russian",
    Spanish = "Spanish",
    Other = "Other",
}

export enum SelfIdentification {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Bisexual = "Bisexual",
    Transgender = "Transgender",
    Lesbian = "Lesbian",
    Gay = "Gay",
    Queer = "Queer",
    Other = "Other",
}

export enum BasedIn {
    Atlanta = "Atlanta",
    Austin = "Austin",
    Chicago = "Chicago",
    LA = "LA",
    Miami = "Miami",
    NY = "NY",
    San_Francisco = "San Francisco",
}

export enum Racial {
    African_American_Black = "African American/Black",
    African_Diaspora = "African Diaspora",
    Arab = "Arab",
    Asian_American = "Asian American",
    Asian_Diaspora = "Asian Diaspora",
    Indigenous = "Indigenous",
    Latinx__Afro_Latinx = "Latinx - Afro Latinx",
    Middle_Eastern = "Middle Eastern",
    Multiracial_multiethnic = "Multiracial/multiethnic",
    Native_American = "Native American",
    South_Asian_American = "South Asian American",
    Other = "Other",
}

export enum DocumentaryExperience {
    Assistant_Editor_Feature = "Assistant Editor: Feature",
    Associate_Editor_Feature___Series__12_credits_ = "Associate Editor: Feature / Series (1-2 credits)",
    Associate_Editor_Feature___Series__3__credits_ = "Associate Editor: Feature / Series (3+ credits)",
    Editor_Feature___Series__12_credits_ = "Editor: Feature / Series (1-2 credits)",
    Editor_Feature___Series__36_credits_ = "Editor: Feature / Series (3-6 credits)",
    Editor_Feature___Series__6__credits_ = "Editor: Feature / Series (6+ credits)",
    Editor_Shorts = "Editor: Shorts",
    Looking_to_Break_In = "Looking to Break In",
    Other = "Other",
}

export enum OtherExperience {
    Branded = "Branded",
    Corporate = "Corporate",
    Music_Video = "Music Video",
    Reality = "Reality",
    Web_Videos = "Web Videos",
}

export interface Images {
    profileImage?: string;
    posters?: Posters;
}

export interface Links2 {
    imdb?: string;
    linkedin?: string;
    website?: string;
    customLink?: string;
}

export enum Position2 {
    Editor = "Editor",
    Junior_Associate_Editor = "Junior/Associate Editor",
    Assistant_Editor = "Assistant Editor",
}

export enum Languages2 {
    Arabic = "Arabic",
    English = "English",
    French = "French",
    German = "German",
    Hindi = "Hindi",
    Japanese = "Japanese",
    Mandarin_Chinese = "Mandarin Chinese",
    Portuguese = "Portuguese",
    Russian = "Russian",
    Spanish = "Spanish",
    Other = "Other",
}

export enum SelfIdentification2 {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Bisexual = "Bisexual",
    Transgender = "Transgender",
    Lesbian = "Lesbian",
    Gay = "Gay",
    Queer = "Queer",
    Other = "Other",
}

export enum BasedIn2 {
    Atlanta = "Atlanta",
    Austin = "Austin",
    Chicago = "Chicago",
    LA = "LA",
    Miami = "Miami",
    NY = "NY",
    San_Francisco = "San Francisco",
}

export enum Racial2 {
    African_American_Black = "African American/Black",
    African_Diaspora = "African Diaspora",
    Arab = "Arab",
    Asian_American = "Asian American",
    Asian_Diaspora = "Asian Diaspora",
    Indigenous = "Indigenous",
    Latinx__Afro_Latinx = "Latinx - Afro Latinx",
    Middle_Eastern = "Middle Eastern",
    Multiracial_multiethnic = "Multiracial/multiethnic",
    Native_American = "Native American",
    South_Asian_American = "South Asian American",
    Other = "Other",
    OtherBIPOC = "Other (BIPOC)",
}

export enum DocumentaryExperience2 {
    Assistant_Editor_Feature = "Assistant Editor: Feature",
    Associate_Junior_Editor_Feature___Series__12_credits_ = "Associate/Junior Editor: Feature / Series (1-2 credits)",
    Associate_Junior_Editor_Feature___Series__3__credits_ = "Associate/Junior Editor: Feature / Series (3+ credits)",
    Editor_Feature___Series__12_credits_ = "Editor: Feature / Series (1-2 credits)",
    Editor_Feature___Series__36_credits_ = "Editor: Feature / Series (3-6 credits)",
    Editor_Feature___Series__6__credits_ = "Editor: Feature / Series (6+ credits)",
    Editor_Shorts = "Editor: Shorts",
    Looking_to_Break_In = "Looking to Break In",
    Other = "Other",
}

export enum OtherExperience2 {
    Branded = "Branded",
    Corporate = "Corporate",
    Music_Video = "Music Video",
    Reality = "Reality",
    Web_Videos = "Web Videos",
}

export interface Images2 {
    profileImage?: string;
    posters?: Posters2;
}

export interface Query {
    position?: Position3[];
    languages?: Languages3[];
    selfIdentification?: SelfIdentification3[];
    BasedIn?: BasedIn3[];
    racial?: Racial3[];
    documentaryExperience?: DocumentaryExperience3[];
    otherExperience?: OtherExperience3[];
    activelyLooking?: number;
}

export interface Email {
    subject?: string;
    message?: string;
}

export interface Resource {
    title?: string;
    subtitle?: string;
    description?: string;
    link?: string;
}

export interface Endorser {
    title?: string;
    subtitle?: string;
}

export interface Highlight {
    title?: string;
    info?: string;
    banner?: string;
    metatag?: string;
    link?: string;
}

export interface Body12 {
    _id?: string;
    name?: string;
    lastName?: string;
    email?: string;
}

export interface Body13 {
    name?: string;
    lastName?: string;
    _id?: string;
    role?: string;
    email?: string;
}

export interface Body14 {
    _id?: string;
    user?: User2;
}

export interface Body15 {
    _id?: string;
    title?: string;
    subtitle?: string;
    description?: string;
    image?: string;
    link?: string;
}

export interface Body16 {
    _id?: string;
    title?: string;
    subtitle?: string;
    image?: string;
}

export interface Body17 {
    _id?: string;
    image?: string;
}

export interface Anonymous55 {
    highlight?: Highlight2[];
}

export interface Body18 extends Anonymous55 {
}

export interface Posters {
    poster1?: Poster1;
    poster2?: Poster2;
    poster3?: Poster3;
}

export interface Posters2 {
    poster1?: Poster;
    poster2?: Poster;
    poster3?: Poster;
}

export enum Position3 {
    Editor = "Editor",
    Junior_Associate_Editor = "Junior/Associate Editor",
    Assistant_Editor = "Assistant Editor",
}

export enum Languages3 {
    Arabic = "Arabic",
    English = "English",
    French = "French",
    German = "German",
    Hindi = "Hindi",
    Japanese = "Japanese",
    Mandarin_Chinese = "Mandarin Chinese",
    Portuguese = "Portuguese",
    Russian = "Russian",
    Spanish = "Spanish",
    Other = "Other",
}

export enum SelfIdentification3 {
    Female = "Female",
    Male = "Male",
    NonBinary = "Non-Binary",
    Bisexual = "Bisexual",
    Transgender = "Transgender",
    Lesbian = "Lesbian",
    Gay = "Gay",
    Queer = "Queer",
    Other = "Other",
}

export enum BasedIn3 {
    Atlanta = "Atlanta",
    Austin = "Austin",
    Chicago = "Chicago",
    LA = "LA",
    Miami = "Miami",
    NY = "NY",
    San_Francisco = "San Francisco",
}

export enum Racial3 {
    African_American_Black = "African American/Black",
    African_Diaspora = "African Diaspora",
    Arab = "Arab",
    Asian_American = "Asian American",
    Asian_Diaspora = "Asian Diaspora",
    Indigenous = "Indigenous",
    Latinx__Afro_Latinx = "Latinx - Afro Latinx",
    Middle_Eastern = "Middle Eastern",
    Multiracial_multiethnic = "Multiracial/multiethnic",
    Native_American = "Native American",
    South_Asian_American = "South Asian American",
    Other = "Other",
}

export enum DocumentaryExperience3 {
    Assistant_Editor_Feature = "Assistant Editor: Feature",
    Associate_Junior_Editor_Feature___Series__12_credits_ = "Associate/Junior Editor: Feature / Series (1-2 credits)",
    Associate_Junior_Editor_Feature___Series__3__credits_ = "Associate/Junior Editor: Feature / Series (3+ credits)",
    Editor_Feature___Series__12_credits_ = "Editor: Feature / Series (1-2 credits)",
    Editor_Feature___Series__36_credits_ = "Editor: Feature / Series (3-6 credits)",
    Editor_Feature___Series__6__credits_ = "Editor: Feature / Series (6+ credits)",
    Editor_Shorts = "Editor: Shorts",
    Looking_to_Break_In = "Looking to Break In",
    Other = "Other",
}

export enum OtherExperience3 {
    Branded = "Branded",
    Corporate = "Corporate",
    Music_Video = "Music Video",
    Reality = "Reality",
    Web_Videos = "Web Videos",
}

export interface User2 {
    _id?: string;
    name?: string;
    lastName?: string;
}

export interface Poster1 {
    referenceLink?: string;
    description?: string;
    credits?: string;
}

export interface Poster2 {
    referenceLink?: string;
    description?: string;
    credits?: string;
}

export interface Poster3 {
    referenceLink?: string;
    description?: string;
    credits?: string;
}

export interface Highlight2 {
    title?: string;
    info?: string;
    banner?: string;
    metatag?: string;
    link?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
